const TRANSFER_LINK_SOURCE_DOWNLOADS = 'dnl'; // "copy link" was used on a /downloads page

export default {
  downloads: TRANSFER_LINK_SOURCE_DOWNLOADS,
};
